import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

export const LOG_LOCATION = 'issue.issue-context-service';
export const localStorage = createLocalStorageProvider('jira_issue_view');
export const VIEW_MODE_STORAGE_KEY = 'view-mode';
